var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0627 6.16862V0.751953H15.5002V6.16862H11.0627ZM5.79183 6.16862V0.751953H10.2293V6.16862H5.79183ZM0.520996 6.16862V0.751953H4.9585V6.16862H0.520996ZM0.520996 12.4186V7.00195H4.9585V12.4186H0.520996ZM5.79183 12.4186V7.00195H10.2293V12.4186H5.79183ZM11.0627 12.4186V7.00195H15.5002V12.4186H11.0627Z",
    fill: "#572148"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModule);
export default __webpack_public_path__ + "static/media/module.e295f50f990302862612d3108e573d93.svg";
export { ForwardRef as ReactComponent };